var map = {
	"./404.vue": "8cdb",
	"./captcha.vue": "598a",
	"./changepassword-first-time-login.vue": "1486",
	"./client-cors-origin/index.vue": "0e55",
	"./client-redirect-uris/index.vue": "b993",
	"./configpassword/index.vue": "1f5e",
	"./forgotpassword.vue": "717f",
	"./index.vue": "1e4b",
	"./login.vue": "dd7b",
	"./logout.vue": "91a3",
	"./manager/2fa.vue": "e1b8",
	"./manager/active-email.vue": "935c",
	"./manager/active-phone.vue": "cd2b",
	"./manager/activity.vue": "e892",
	"./manager/address/create.vue": "e461",
	"./manager/address/index.vue": "122b",
	"./manager/change-email.vue": "dbf8",
	"./manager/change-password.vue": "c9f5",
	"./manager/change-phone.vue": "912c",
	"./manager/default-language.vue": "f9e9",
	"./manager/delete.vue": "61ba",
	"./manager/device/detail.vue": "31f0",
	"./manager/device/index.vue": "cb6e",
	"./manager/email/index.vue": "4f53",
	"./manager/index.vue": "5d3f",
	"./manager/info/index.vue": "c4e1",
	"./manager/kyc.vue": "7e9c",
	"./manager/logout.vue": "8211",
	"./manager/notification-config.vue": "027e",
	"./manager/phone/index.vue": "9629",
	"./manager/point-history.vue": "9486",
	"./manager/profile-edit.vue": "6cb2",
	"./manager/profile.vue": "9017",
	"./manager/recovery-ways.vue": "4bc1",
	"./manager/set-password.vue": "a00a",
	"./manager/token.vue": "e015",
	"./oidc/callback.vue": "108b",
	"./oidc/error.vue": "6908",
	"./oidc/logout.vue": "8a13",
	"./oidc/silent-renew.vue": "dcae",
	"./register.vue": "7803",
	"./role/index.vue": "6c35",
	"./user/index.vue": "e382"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "feca";